import React from "react";

function NetCashFlow({ settlementDetails }) {
  const addValue = (item1, item2) => {
    return Math.round(parseFloat(item1) + parseFloat(item2));
  };

  return (
    <>
      <table className="table profit-loss table-borderless">
        <thead>
          <tr>
            <th
              className="tableData tdBolder"
              style={{ borderTopLeftRadius: "16px" }}
            >
              Net Cash Flow (Total)
            </th>
            <th
              className="text-center"
              style={{ borderTopRightRadius: "16px" }}
            >
              <div className="row">
                <div className="col tableHead">Net Revenue</div>
                <div className="col tableHead">WTF Share</div>
                <div className="col tableHead">Gym Share</div>
                <div className="col tableHead">GST on WTF Facilities</div>
                <div className="col tableHead">Bill Raised to GYM</div>
                <div className="col tableHead">GST Collected</div>
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th
              className="tableData tdBolder"
              style={{ background: "#FF8F6B" }}
            >
              Basic Membership
            </th>
            <td className="tableData" style={{ background: "#FF8F6B" }}>
              <div className="row">
                <div className="col">
                  ₹
                  {Math.round(
                    parseFloat(settlementDetails?.data?.[0]?.net_revenue)
                  )}
                </div>
                <div className="col">
                  ₹
                  {settlementDetails?.data?.length > 0
                    ? settlementDetails?.revenue_share_regular_membership
                        ?.wtf_share
                    : "N/A"}
                </div>
                <div className="col">
                  ₹
                  {settlementDetails?.data?.length > 0
                    ? settlementDetails?.gym_share_final
                    : 0}
                </div>
                <div className="col">
                  <span className="">
                    ₹
                    {settlementDetails?.data?.length > 0
                      ? settlementDetails?.gst_wtf_facilities
                      : 0}
                  </span>
                </div>
                <div className="col">
                  <span className="">
                    ₹
                    {settlementDetails?.data?.length > 0
                      ? settlementDetails?.bill_raised_gym
                      : 0}
                  </span>
                </div>
                <div className="col">
                  <span className="">
                    ₹
                    {settlementDetails?.data?.length > 0
                      ? settlementDetails?.data[0]?.gst
                      : 0}
                  </span>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <th
              className="tableData tdBolder"
              style={{ background: "#FFC327" }}
            >
              Other Membership
            </th>
            <td className="tableData" style={{ background: "#FFC327" }}>
              <div className="row">
                <div className="col">
                  ₹{settlementDetails?.cash_flow_other_membership?.net_revenue}
                </div>
                <div className="col">
                  ₹
                  {
                    settlementDetails?.cash_flow_other_membership
                      ?.total_wtf_share
                  }
                </div>
                <div className="col">
                  ₹
                  {
                    settlementDetails?.cash_flow_other_membership
                      ?.total_gym_share
                  }
                </div>
                <div className="col">
                  <span className="">
                    ₹
                    {
                      settlementDetails?.cash_flow_other_membership
                        ?.gst_wtf_facilities
                    }
                  </span>
                </div>
                <div className="col">
                  <span className="">
                    ₹
                    {
                      settlementDetails?.cash_flow_other_membership
                        ?.bill_raised_gym
                    }
                  </span>
                </div>
                <div className="col">
                  <span className="">
                    ₹{settlementDetails?.cash_flow_other_membership?.gst}
                  </span>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <th
              className="tableData tdBolder bgBlack"
              style={{ borderBottomLeftRadius: "16px" }}
            >
              Total
            </th>
            <th
              className="tableData bgBlack"
              style={{ borderBottomRightRadius: "16px" }}
            >
              <div className="row">
                <div className="col">
                  ₹
                  {addValue(
                    settlementDetails.data?.[0]?.net_revenue,
                    settlementDetails?.cash_flow_other_membership?.net_revenue
                  )}
                </div>
                <div className="col">
                  ₹
                  {addValue(
                    settlementDetails?.revenue_share_regular_membership
                      ?.wtf_share,
                    settlementDetails?.cash_flow_other_membership
                      ?.total_wtf_share
                  )}
                </div>
                <div className="col">
                  ₹
                  {addValue(
                    settlementDetails?.data?.length > 0
                      ? settlementDetails?.gym_share_final
                      : 0,
                    settlementDetails?.cash_flow_other_membership
                      ?.total_gym_share
                  )}
                </div>
                <div className="col">
                  <span className="">
                    ₹
                    {addValue(
                      settlementDetails?.data?.length > 0
                        ? settlementDetails?.gst_wtf_facilities
                        : 0,
                      settlementDetails?.cash_flow_other_membership
                        ?.gst_wtf_facilities
                    )}
                  </span>
                </div>
                <div className="col">
                  <span className="">
                    ₹
                    {addValue(
                      settlementDetails?.data?.length > 0
                        ? settlementDetails?.bill_raised_gym
                        : 0,
                      settlementDetails?.cash_flow_other_membership
                        ?.bill_raised_gym
                    )}
                  </span>
                </div>
                <div className="col">
                  <span className="">
                    ₹
                    {addValue(
                      settlementDetails?.cash_flow_other_membership?.gst,
                      settlementDetails?.data?.length > 0
                        ? settlementDetails?.data[0]?.gst
                        : 0
                    )}
                  </span>
                </div>
              </div>
            </th>
          </tr>
        </tbody>
      </table>
    </>
  );
}

export default NetCashFlow;
